/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { Mesh } from 'three';
import React, { useRef } from 'react';
import { useGLTF } from '@react-three/drei';
import { GLTF } from 'three-stdlib';
import { a } from '@react-spring/three';
import { useSpring } from '@react-spring/three';
import { useFrame } from '@react-three/fiber';
import type { BustTypes } from '../types';

type GLTFResult = GLTF & {
  nodes: {
    ['lynn_meshtrimmed_(1)']: Mesh;
  };
};

const Lynn: React.FC<BustTypes> = ({ active, outConfig, inConfig }: BustTypes) => {
  const { nodes } = useGLTF('/objects/lynn.glb') as unknown as GLTFResult;
  const mesh = useRef<Mesh>(new Mesh());

  const { outPosition } = useSpring({
    outPosition: active ? 0 : 5,
    outConfig
  });

  const { inPosition } = useSpring({
    inPosition: active ? 0 : -5,
    inConfig
  });

  useFrame(state => {
    if (mesh?.current && active) {
      mesh.current.rotation.y += 0.01;
    }
  });
  return (
    <a.mesh
      ref={mesh}
      geometry={nodes['lynn_meshtrimmed_(1)'].geometry}
      position-x={0}
      position-y={active ? inPosition : outPosition}
      position-z={0}
      rotation-z={Math.PI}
    >
      <meshStandardMaterial color={0xffffff} roughness={0} metalness={1} />
    </a.mesh>
  );
};

export default Lynn;
